import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles((theme) => ({
  tableHead: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '140%',
    letterSpacing: 0,
    backgroundColor: theme.palette.grey[100],
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    '& th:not(:first-child)': {
      position: 'relative',
      '&::before': {
        content: '""',
        width: 1,
        height: '1rem',
        top: 0,
        left: 0,
        bottom: 0,
        margin: 'auto',
        position: 'absolute',
        backgroundColor: theme.palette.grey[300],
      },
    },
  },
  tableBody: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '140%',
    letterSpacing: 0,
  },
  tableRow: {
    '& td': {
      paddingTop: 12,
      paddingBottom: 12,
    },
  },
  mobileShoppingRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    padding: 16,
    borderBottom: '1px solid #e4e4e4',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  paymentInfo: {
    display: 'flex',
    flexDirection: 'row',
    gap: 4,
  },
  image: {
    width: 40,
    minWidth: 40,
    height: 40,
    backgroundColor: '#e6e6e6',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    border: '1px solid #e4e4e4',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 200,
    },
  },
  title: {
    padding: '0 8px',
    color: theme.palette.grey[600],
    [theme.breakpoints.down('sm')]: {
      padding: '8px 0 0',
    },
    '& span': {
      display: 'block',
      color: '#666',
      fontSize: 14,
      fontWeight: 400,
      '& a': {
        color: theme.palette.secondary.main,
        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },
  },
  paymentType: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  options: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      marginTop: 8,
      justifyContent: 'center',
    },
    '& svg': {
      width: 14,
      fill: '#666',
      cursor: 'pointer',
      [theme.breakpoints.down('sm')]: {
        width: 28,
      },
    },
  },
  productContainer: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
}));

export default useStyle;
